<!--
* @Name：采购评标公告审批基本页面
* @Author: 王超
* @Date: 2025-10-13 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-10-13 10:39:49
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="询价比授标审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">基本信息</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="suppDetail">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">供应商基本信息</span>
        </template>
        <supp-details :details-list="suppInfo" />
      </van-collapse-item>
      <van-collapse-item name="suppInfoList">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">供应商营业业绩</span>
        </template>
        <supp-info-list :supp-info-list="suppInfo" />
      </van-collapse-item>
      <van-collapse-item name="suppControlInfo">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">采购过程控制</span>
        </template>
        <supp-control-info :supp-control-info="controlTimeInfo" :supp-info-list="suppInfo" />
      </van-collapse-item>
      <van-collapse-item name="suppEnquiryInfo">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">报价信息对比</span>
        </template>
        <supp-enquiry-info :price-comp-supp="suppControlInfo" :main-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="bidResult">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">授标结果</span>
        </template>
        <supp-bid-result-list :supp-info-list="bidResultList" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import {
  selectSuppInfoByPcInfoId,
  selectPriceCompInfoById,
  selectAwardInfoByPcInfoId,
  searchPriceCompSupp
} from '@/api/purEvaluationReportApproval'
import Bridge from '@/components/dsbridge'
export default {
  name: 'PoApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'supp-details': () => import('./components/SuppDetails.vue'),
    'supp-info-list': () => import('./components/SuppInfoList.vue'),
    'supp-control-info': () => import('./components/SuppControlInfo.vue'),
    'supp-enquiry-info': () => import('./components/SuppEnquiryInfo.vue'),
    'supp-bid-result-list': () => import('./components/SuppBidResultList.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      headInfo: {},
      // 供应商信息
      suppInfo: [],
      // 采购过程控制
      suppControlInfo: {},
      controlTimeInfo: {},
      priceCompSupp: {},
      bidResultList: [],
      attachList: [],
      businessKey: ''
    }
  },
  mounted() {
    if (this.$route.query.businessKey.includes('_')) {
      const index = this.$route.query.businessKey.indexOf('_')
      this.businessKey = this.$route.query.businessKey.substring(0, index)
    } else {
      this.businessKey = this.$route.query.businessKey
    }
    this.initData()
  },
  methods: {
    async initData() {
      const compInfoResp = await selectPriceCompInfoById({ pcInfoId: this.businessKey })
      this.headInfo = compInfoResp.data
      const suppInfoResp = await selectSuppInfoByPcInfoId({ pcInfoId: this.businessKey })
      this.suppInfo = suppInfoResp.data
      const suppControlResp = await selectAwardInfoByPcInfoId({ projectId: this.businessKey })
      this.suppControlInfo = suppControlResp.data
      this.controlTimeInfo = this.suppControlInfo.pmPriceCompInfoDTO
      this.bidResultList = this.suppControlInfo.subjectList
      const priceCompSuppResp = await searchPriceCompSupp({ pcInfoId: this.businessKey })
      this.priceCompSupp = priceCompSuppResp.data
    },
    onClickLeft() {
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
